import { useId, useRef } from "react";
import { useElementDimensions } from "@/hooks/use-element-dimensions";
import type { TimeAxisPanelSpec } from "../ChartSpec";
import { useSpec } from "../spec/spec-context";
import { Panel } from "./panel";

export function PanelStack({ resizable = true }: { resizable?: boolean }) {
    const { spec } = useSpec();
    const stackRef = useRef<HTMLDivElement | null>(null);
    const { dimensions: stackDimensions } = useElementDimensions({ ref: stackRef });

    // One width group for the whole stack: every panel publishes its gutter requirement here, so
    // they all render with the same max-reduced gutters and their plot areas stay column-aligned.
    const groupId = useId();

    /* TODO: maybe some css styling to better handle multiple panels? */
    return (
        <div ref={stackRef} className={"w-full"}>
            {spec.panels.map((panel) => (
                // TODO: Add guards for various panel types
                <Panel
                    key={panel.id}
                    spec={panel as TimeAxisPanelSpec}
                    groupId={groupId}
                    maxStackWidth={stackDimensions.width}
                    resizable={resizable}
                />
            ))}
        </div>
    );
}
